import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DoneIcon from '@mui/icons-material/Done';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Box, Button, Grid, Typography } from '@mui/material';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import AppLoader from '../../../components/AppLoader/AppLoader';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import * as Yup from "yup";
import { cfpBaseUrl } from '../../../network/urls';
import { documentValidation } from '../../../services/Functions';
import "../ChangeOfAttributes/ChangeOfAttributesForm.scss";
import { documentExtensions } from '../../../utils/PortalName';
import {
    isLegacyReuploadDocumentEditable,
    LegacyServerDocumentPreview,
} from '../../../components/ReuploadDocuments/reuploadDocumentUi';

const Changeofloadupdatedocuments = () => {

    const initialValues = {
        // Required Documents Initial Values
        iv_applicant_cnic_front: null,
        iv_applicant_cnic_back: null,
        iv_owenership_document: null,
        iv_test_report: null,
    }

    // Documents states
    const [applicantCNICFront, setApplicantCnicFront] = useState('');
    const [applicantCNICBack, setApplicantCnicBack] = useState('');
    const [owenershipDocument, setOwenershipDocument] = useState('');
    const [testReport, setTestReport] = useState('');
    // Thumbnail states
    const [applicantCNICFrontThumbnail, setApplicantCnicFrontThumbnail] = useState('');
    const [applicantCNICBackThumbnail, setApplicantCnicBackThumbnail] = useState('');
    const [owenershipDocumentThumbnail, setOwenershipDocumentThumbnail] = useState('');
    const [testReportThumbnail, setTestReportThumbnail] = useState('');
    // Error states
    const [applicantCNICFrontError, setApplicantCnicFrontError] = useState('');
    const [applicantCNICBackError, setApplicantCnicBackError] = useState('');
    const [owenershipDocumentError, setOwenershipDocumentError] = useState('');
    const [testReportError, setTestReportError] = useState('');

    const [connectionType, setConnectionType] = useState()
    const [applicantStatus, setApplicantStatus] = useState()
    const [isLoadingSpinner, setIsLoadingSpinner] = useState(false)

    const { state } = useLocation();
    const { dialogRowData } = state;
    const [dialogRowDataLocal, setDialogRowDataLocal] = useState();

    var { token, code: officeCode, hierarchy: officeHierarchy, showAllApplicationsFlag, userId } = useSelector((state) => state.auth)

    const navigate = useNavigate();

    useEffect(() => {
        if (dialogRowData) {
            let dialogData = dialogRowData
            setDialogRowDataLocal(dialogData)
        }
    }, [dialogRowData])

    useEffect(() => {
        if (dialogRowData.applicantCNICFront) {
            values.iv_applicant_cnic_front = dialogRowData.applicantCNICFront
            setApplicantCnicFrontThumbnail(dialogRowData.applicantCNICFront)
        }
        if (dialogRowData.applicantCNICBack) {
            values.iv_applicant_cnic_back = dialogRowData.applicantCNICBack
            setApplicantCnicBackThumbnail(dialogRowData.applicantCNICBack)
        }
        if (dialogRowData.owenershipImage) {
            values.iv_owenership_document = dialogRowData.owenershipImage
            setOwenershipDocumentThumbnail(dialogRowData.owenershipImage)
        }
        if (dialogRowData.testReport) {
            values.iv_test_report = dialogRowData.testReport
            setTestReportThumbnail(dialogRowData.testReport)
        }
    }, [dialogRowData])

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
        useFormik({
            initialValues,
            validationSchema: Yup.object({
                // Required Documents Validation
                iv_applicant_cnic_front: Yup.mixed().required('Please upload cnic in jpg, jpeg, png or pdf format.'),
                iv_applicant_cnic_back: Yup.mixed().required('Please upload cnic in jpg, jpeg, png or pdf format.'),
                iv_owenership_document: Yup.mixed().required('Please upload ownership document in jpg, jpeg, png or pdf format.'),
                iv_test_report: Yup.mixed().optional(),
            }),
            onSubmit: async (values, { resetForm }) => {
                setIsLoadingSpinner(true);
                var formdata = new FormData();

                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);;
                formdata.append("applicantCNICFront", applicantCNICFrontThumbnail);
                formdata.append("applicantCNICBack", applicantCNICBackThumbnail);
                formdata.append("owenershipImage", owenershipDocumentThumbnail);
                if (testReportThumbnail) {
                    formdata.append("testReport", testReportThumbnail);
                } else {
                    formdata.append("testReport", '');
                }
                formdata.append("applicationId", dialogRowData.applicationId);


                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };

                await fetch(cfpBaseUrl + "changeOfLoad/updateChangeOfLoadDocuments", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            var formdata = new FormData();
                            formdata.append("applicationNo", dialogRowData.applicationId);
                            const myHeaders = new Headers();
                            myHeaders.append("Authorization", token);;
                            formdata.append("applicantCNICFrontFlag", "");
                            formdata.append("applicantCNICBackFlag", "");
                            formdata.append("owenershipDocumentFlag", "");
                            formdata.append("testReportFlag", "");
                            var requestOptions = {
                                method: 'POST',
                                body: formdata,
                                headers: myHeaders,
                                redirect: 'follow',
                            };
                            fetch(cfpBaseUrl + "changeOfLoad/updateCOLDocumentFlag", requestOptions)
                                .then(response => response.json())
                                .then(result => {
                                    if (result.status === "200") {
                                        var formdata = new FormData();
                                        formdata.append("applicationId", dialogRowData.applicationId);
                                        formdata.append("objectionStatus", 2);
                                        formdata.append("remarks", "Documents Reuploaded");
                                        formdata.append("remarksDetail", "-");
                                        formdata.append("lastModifiedBy", userId);
                                        const myHeaders = new Headers();
                                        myHeaders.append("Authorization", token);;
                                        var requestOptions = {
                                            method: 'POST',
                                            body: formdata,
                                            headers: myHeaders,
                                            redirect: 'follow',
                                        };
                                        fetch(cfpBaseUrl + "comman/changeObjectionStatus", requestOptions)
                                            .then(response => response.json())
                                            .then(result => {
                                                if (result.status === '200') {
                                                    setTimeout(() => {
                                                        navigate('/change-of-load-table')
                                                    }, 2000)
                                                }
                                                else {
                                                }
                                            })
                                            .catch(() => {});
                                    }
                                })
                                .catch(() => {});
                        }
                        else {
                            setIsLoadingSpinner(false)
                        }
                    })
                    .catch(error => {
                        setIsLoadingSpinner(false)
                    });
            }
        })

    //Function to set states of documents
    const ApplicantCnicFront = (event) => {
        handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "applicantCNICFrontFront." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setApplicantCnicFront(renamedFile);
                const reader = new FileReader();

                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setApplicantCnicFrontThumbnail(e.target.result);
                };

                reader.readAsDataURL(file);
            } else if (documentValidate === 2) {
                setApplicantCnicFrontError("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                setApplicantCnicFrontError("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const ApplicantCnicBack = (event) => {
        handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "applicantCNICFrontBack." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setApplicantCnicBack(renamedFile);
                const reader = new FileReader();

                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setApplicantCnicBackThumbnail(e.target.result);
                };

                reader.readAsDataURL(file);
            } else if (documentValidate === 2) {
                setApplicantCnicBackError("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                setApplicantCnicBackError("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const OwenershipDocument = (event) => {
        handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "owenershipDocument." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setOwenershipDocument(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setOwenershipDocumentThumbnail(e.target.result);
                };
                reader.readAsDataURL(file);
            }
            else if (documentValidate === 2) {
                setOwenershipDocumentError("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                setOwenershipDocumentError("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            };
        }
    }

    const TestReport = (event) => {
        handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "testReport." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setTestReport(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setTestReportThumbnail(e.target.result);
                };
                reader.readAsDataURL(file);
            } else if (documentValidate === 2) {
                setTestReportError("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                setTestReportError("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    return (
        <Grid container className='nC'>
            <Box className='nCContainer'>
                <Typography variant='h6' className='heading'>
                    Change of Load Form
                </Typography>
                <Box className="progressBarBackground">
                    <Box className="progressBarContainer">
                        <Box className="pbDocGroup">
                            <Typography className="badge">
                                {
                                    (dialogRowData.applicantCNICFront && dialogRowData.applicantCNICBack) || (applicantCNICFront && applicantCNICBack)
                                        ?
                                        <Box className='backgroundAttached'>
                                            <DoneIcon className='icon' />
                                        </Box> :
                                        <p className='backgroundUnAttached'>1</p>
                                }
                            </Typography>
                            <Typography className='badgeText'>Applicant's CNIC.</Typography>
                        </Box>
                        <Box className="pbDocGroup">
                            <Typography className="badge">
                                {
                                    dialogRowData.owenershipImage || owenershipDocument
                                        ?
                                        <Box className='backgroundAttached'>
                                            <DoneIcon className='icon' />
                                        </Box> :
                                        <p className='backgroundUnAttached'>2</p>
                                }
                            </Typography>
                            <Typography className='badgeText'>Ownership Documents</Typography>
                        </Box>
                        <Box className="pbDocGroup">
                            <Typography className="badge">
                                {
                                    dialogRowData.testReport || (testReport)
                                        ?
                                        <Box className='backgroundAttached'>
                                            <DoneIcon className='icon' />
                                        </Box> :
                                        <p className='backgroundUnAttached'>3</p>
                                }
                            </Typography>
                            <Typography className='badgeText'>Test Report</Typography>
                        </Box>
                    </Box>
                </Box>

                <form className='ncform' style={{ marginRight: '20px' }}>
                    <Typography variant="h6" className='groupTitle' >
                        Application Details
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={4}>
                            <Typography className='fieldLabel' > Application Id</Typography>
                            <TextField
                                required
                                type='text'
                                name="iv_applied_load"
                                value={dialogRowData.applicationId}
                                disabled
                                id="iv_applied_load"
                                className='textInputField'
                            />
                        </Grid>
                    </Grid>
                    <Typography variant="h6" className='groupTitle'>
                        Documents
                    </Typography>
                    <Grid container spacing={1} className='documentsContainer' >
                        <Grid item lg='2' >
                            <Typography className='documentLabel' >1- Applicant's CNIC.</Typography>
                            <Box className='documentError'>{(errors.iv_applicant_cnic_front && touched.iv_applicant_cnic_front) || (errors.iv_applicant_cnic_back && touched.iv_applicant_cnic_back) ? (errors.iv_applicant_cnic_front) : null}</Box>
                        </Grid>
                        <Grid item lg='1'>
                            {
                                dialogRowData.applicantCNICFront ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <LegacyServerDocumentPreview
                                                thumbnail={applicantCNICFrontThumbnail}
                                                flag={dialogRowData.applicantCNICFrontFlag}
                                                alt="Applicant CNIC Front"
                                            />
                                        </Grid>
                                        {
                                            isLegacyReuploadDocumentEditable(dialogRowData.applicantCNICFrontFlag) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_applicant_cnic_front' name='iv_applicant_cnic_front' type="file" onChange={ApplicantCnicFront} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    applicantCNICFront ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setApplicantCnicFront('') }} />}  >
                                                {applicantCNICFrontThumbnail && <img src={applicantCNICFrontThumbnail} alt="Applicant CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_applicant_cnic_front' name='iv_applicant_cnic_front' type="file" onChange={ApplicantCnicFront} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='1'>
                            {
                                dialogRowData.applicantCNICBack ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <LegacyServerDocumentPreview
                                                thumbnail={applicantCNICBackThumbnail}
                                                flag={dialogRowData.applicantCNICBackFlag}
                                                alt="Applicant CNIC Back"
                                            />
                                        </Grid>
                                        {
                                            isLegacyReuploadDocumentEditable(dialogRowData.applicantCNICBackFlag) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_applicant_cnic_back' name='iv_applicant_cnic_back' type="file" onChange={ApplicantCnicBack} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    applicantCNICBack ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setApplicantCnicBack('') }} />}  >
                                                {applicantCNICBackThumbnail && <img src={applicantCNICBackThumbnail} alt="Applicant CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_applicant_cnic_back' name='iv_applicant_cnic_back' type="file" onChange={ApplicantCnicBack} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='2' >
                            <Typography className='documentLabel' >2- Ownership Documents</Typography>
                            <Box className='documentError'>{errors.iv_owenership_document && touched.iv_owenership_document ? (errors.iv_owenership_document) : null}</Box>
                        </Grid>
                        <Grid item lg='2'>
                            {
                                dialogRowData.owenershipImage ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <LegacyServerDocumentPreview
                                                thumbnail={owenershipDocumentThumbnail}
                                                flag={dialogRowData.owenershipImageFlag}
                                                alt="Ownership Document"
                                            />
                                        </Grid>
                                        {
                                            isLegacyReuploadDocumentEditable(dialogRowData.owenershipImageFlag) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_owenership_document' name='iv_owenership_document' type="file" onChange={OwenershipDocument} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    owenershipDocument ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setOwenershipDocument('') }} />}  >
                                                {owenershipDocumentThumbnail && <img src={owenershipDocumentThumbnail} alt="Applicant CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_owenership_document' name='iv_owenership_document' type="file" onChange={OwenershipDocument} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='2' >
                            <Typography className='documentLabel' >3- Test Report</Typography>
                            <Box className='documentError'>{errors.iv_test_report && touched.iv_test_report ? (errors.iv_test_report) : null}</Box>
                        </Grid>
                        <Grid item lg='1'>
                            {
                                dialogRowData.testReport ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <LegacyServerDocumentPreview
                                                thumbnail={testReportThumbnail}
                                                flag={dialogRowData.testReportFlag}
                                                alt="Test Report"
                                            />
                                        </Grid>
                                        {
                                            isLegacyReuploadDocumentEditable(dialogRowData.testReportFlag) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >

                                                    <input hidden accept={documentExtensions} id='iv_test_report' name='iv_test_report' type="file" onChange={TestReport} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    testReport ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setTestReport('') }} />}  >
                                                {testReportThumbnail && <img src={testReportThumbnail} alt="Owner CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_test_report' name='iv_test_report' type="file" onChange={TestReport} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                    </Grid>
                    <Box sx={{ marginTop: '8%', textAlign: 'right' }}>
                        <Button sx={{ width: '10%', marginLeft: '1%', marginBottom: '1%' }} variant='contained' component="label" type='submit' onClick={handleSubmit} disabled={isLoadingSpinner}>
                            {isLoadingSpinner ? (
                                <Box sx={{ display: 'flex' }}>
                                    <AppLoader />
                                </Box>
                            ) : (
                                'Submit'
                            )}
                        </Button>
                    </Box>
                </form >
            </Box >
        </Grid >
    )
}

export default Changeofloadupdatedocuments
